import {
    CurrencyCode,
    findCurrencySymbolByCode,
    formatCurrency,
    formatNumber,
    getCurrencyFromRegion,
    getPricingUnit,
    getRegion,
    getTradeUnit,
    ListingBuyerModel,
    TranslateFunc,
} from '@steelbuy/ts-shared';
import { getQualityDisplayValue } from './QualityUtil';
import { buildProductName } from './RFQUtil';

export const getProductName = (listing: ListingBuyerModel, t: TranslateFunc): string => buildProductName(listing, t);

type ListingTableConfig = Partial<
    Record<
        string,
        {
            getHeading: (
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                formData: Record<string, any>,
                t: TranslateFunc
            ) => string;
            mapValue?: (listing: ListingBuyerModel, t: TranslateFunc) => string | number | undefined;
            getTooltip?: (t: TranslateFunc) => string | number | undefined;
        }
    >
>;

export const listingTableConfig: ListingTableConfig = {
    productName: {
        getHeading: (formData, t) => t('application.dashboardListings.tableHeadings.productName'),
        mapValue: getProductName,
    },
    gauge: {
        getHeading: (formData, t) => t('application.dashboardListings.tableHeadings.gauge'),
        mapValue: (listing) => listing.gauge ?? '',
    },
    quality: {
        getHeading: (formData, t) => t('application.dashboardListings.tableHeadings.quality'),
        mapValue: (listing, t) => getQualityDisplayValue(listing.quality, listing.prime, t),
    },
    location: {
        getHeading: (formData, t) => t('application.dashboardListings.tableHeadings.location'),
        mapValue: (listing, t) => {
            const locationTextArray = [];
            if (listing.state) {
                locationTextArray.push(t(`domainModel:address.shortState.${listing.state}`));
            }
            if (listing.country) {
                locationTextArray.push(t(`domainModel:address.shortCountry.${listing.country}`));
            }
            return locationTextArray.length ? locationTextArray.join(', ') : '';
        },
    },
    weight: {
        getHeading: (formData, t) =>
            t('application.createBulkListing.fields.weight', {
                tradeUnit: t(`domainModel:material.tradeUnit.value.${getTradeUnit(formData)}.label`),
            }),
        mapValue: (listing) => formatNumber(listing.weight),
    },
    price: {
        getHeading: (formData, t) =>
            `${findCurrencySymbolByCode(getCurrencyFromRegion(getRegion()) as CurrencyCode)}/${t(
                `domainModel:material.pricingUnit.value.${getPricingUnit(formData)}.label`
            )}`,
        mapValue: (listing: ListingBuyerModel) => {
            if (listing?.pricing?.priceIncludingDelivery) {
                return formatCurrency(
                    listing.pricing.priceIncludingDelivery.value,
                    getCurrencyFromRegion(getRegion()) as CurrencyCode
                );
            }
            return '';
        },
        getTooltip: (t) => t('application.dashboardListings.deliveredTotal'),
    },
};
